import { discountApplicableType, discountType, taxMode } from '@/utils/enums'
import moment from 'moment'

export const POSFunctionalMixins = {
  computed: {
    cal_process_sub_total() {
      return (tr, saleTaxMode) => {
        if (tr.discount_amount_type === discountApplicableType.postTax && tr.discountType === discountType.dollar && saleTaxMode === taxMode.taxIncluded) {
          if (tr.productData.tieredPricingGroup) {
            let productDiscountObj = null
            let productItemQuantityGrams = tr.sales_qty
            if (tr.productData.categoryId !== this.categories.FLOWER || tr.productData.categoryId !== this.categories.SHAKE) {
              productItemQuantityGrams = this.convertAvailableQty(tr.sales_qty, tr.product.weight_type)['grams']
              productDiscountObj = tr.productData.tieredPricingGroup.pricingFlows.find(x => {
                if (x.weight_type === productItemQuantityGrams) {
                  return true
                }

                if (productItemQuantityGrams >= x.weight_quantity && productItemQuantityGrams <= x.weight_quantity + tr.productData.tieredPricingGroup.weightHeavyAmount) {
                  return true
                }
              })
            } else {
              productDiscountObj = tr.productData.tieredPricingGroup.pricingFlows.find(x => {
                if (x.weight_quantity === tr.sales_qty) {
                  return true
                }

                if (productItemQuantityGrams >= x.weight_quantity && productItemQuantityGrams <= x.weight_quantity + tr.productData.tieredPricingGroup.weightHeavyAmount) {
                  return true
                }
              })
            }

            if (productDiscountObj) {
              const tempTot = productDiscountObj.pricing_value / productItemQuantityGrams
              const taxRate = tempTot / tr.price_per_unit

              return (tempTot * tr.sales_qty - Number(tr.tot_discount)) / taxRate - tr.redeem_dollar
            } else {
              const taxRate = tr.productData.sales_price / tr.price_per_unit
              return (tr.productData.sales_price * tr.sales_qty - Number(tr.tot_discount)) / taxRate - tr.redeem_dollar
            }
          } else {
            const taxRate = tr.productData.sales_price / tr.price_per_unit
            return (tr.productData.sales_price * tr.sales_qty - Number(tr.tot_discount)) / taxRate - tr.redeem_dollar
          }
        }

        const saleItemDate = moment(tr.created_at).format('YYYY-MM-DD HH:mm:ss')
        const discountFeatureAppliedDate = moment('08-31-2021 24:00:00').format('YYYY-MM-DD HH:mm:ss')
        if (moment(saleItemDate).isBefore(discountFeatureAppliedDate)) {
          return tr.tot_price - Number(tr.tot_discount) - tr.redeem_dollar
        }

        return tr.tot_price
      }
    }
  }
}
